import { Skeleton } from "@/components/ui/skeleton";

/** Loading placeholder mirroring TicketHistory (passenger tabs + e-ticket cards). */
export function TicketHistorySkeleton() {
  return (
    <div className="w-full py-5">
      <div className="flex gap-2">
        {["w-20", "w-24", "w-16"].map((width) => (
          <Skeleton key={width} className={`h-9 ${width} rounded-md`} />
        ))}
      </div>
      <div className="mt-4 space-y-2">
        {["etk-1", "etk-2"].map((id) => (
          <div key={id} className="rounded-lg border border-gray-300 bg-white px-4 py-5 shadow-sm">
            <div className="flex items-start justify-between gap-4">
              <div className="flex gap-x-4">
                <Skeleton className="h-10 w-10 rounded-full" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-56" />
                  <Skeleton className="h-3 w-40" />
                  <Skeleton className="h-3 w-36" />
                </div>
              </div>
              <div className="hidden sm:flex sm:flex-col sm:items-end sm:gap-2">
                <Skeleton className="h-3 w-24" />
                <Skeleton className="h-4 w-20" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
